/*
 *
 * Description:
 *   Handles React Animated Logo
 * EIF400 -- Paradigmas de Programacion
 * @since II Term - 2021
 * @authors Team 01-10am
 *  - Andres Alvarez Duran 117520958 
 *  - Joaquin Barrientos Monge 117440348
 *  - Oscar Ortiz Chavarria 208260347
 *  - David Zarate Marin 116770797
 *   Example taken from: https://www.decolore.net/react-animation-examples/
 */
const Reactive = () => {
  return (
    <div className="contenedor">
      <section>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </section>
    </div>
  );
};

export default Reactive;
